//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'page-loader',
};
